<template>
  <div v-if="checkAuth === null">
    Loading..
  </div>
  <div v-else-if="checkAuth === false">
    auth fail
  </div>


  <div data-grm-comp="SysAdminMain" class="layer"
     v-else-if="checkAuth === true"
     @click="showComponent"
  >
    <System />
    <Room />
    <RoomUser />
    <RoomCall />
    <RoomCallMixer />
  </div>
</template>

<script>

import {SysAdmin} from "@/core/sysadmin/sysadmin.api";
import System from "@/components/Sysadmin/System";
import Room from "@/components/Sysadmin/Room";
import RoomUser from "@/components/Sysadmin/RoomUser";
import RoomCall from "@/components/Sysadmin/RoomCall";
import RoomCallMixer from "@/components/Sysadmin/RoomCallMixer";

export default {
  name: 'SysAdminMain',
  components: {
    System,
    Room, RoomUser,
    RoomCall,
    RoomCallMixer,
  },

  data() {
    return {
      checkAuth: null,
    }
  },

  async beforeCreate() {
    if(await SysAdmin.checkAuth()){
      this.checkAuth = SysAdmin.hasSysAdminRole()
      console.log('# check auth :', this.checkAuth)
    }
  },
  async created() {

  },
  methods: {
    showComponent(e){
      // console.log(e);
      if(e.target.matches('.api-layer > fieldset > legend')){
        const el = e.target.closest('.api-layer');
        let show = el.getAttribute('data-api-show');
        el.setAttribute('data-api-show', show==='true' ? 'false' : 'true');
      }
    },
  },
}
</script>

<style lang="scss">
body {
  background-color: #f3f3f3 !important;
}

.layer {
  .api-layer:nth-child(2n-1) {
    background-color: #ebfaff;;
  }
}

.api-layer {
  width: 100%;
  height: 100%;
  padding: 2px;
  font-size: 10px;

  &:not([data-api-show="true"]){
    fieldset {
      min-height: 20px;
      cursor: pointer;

      &:hover {
        background-color: #a0ebfe;
      }
    }
    .api-box {
      display: none !important;
    }
  }

  fieldset {
    legend {
      padding: 4px;
      cursor: default;
      &:hover {
        background-color: #0cf;
      }
    }
  }

  .api-box {
    border: 1px solid #7a7a7a;
    margin: 2px;

    &:hover {
      background-color: #e3e3e3;
    }

    &.inline {
      display: inline-block;
    }

    .api-title {
      display: inline-block;
      min-width: 50px;
      padding: 2px 2px 3px 3px;
      margin-right: 2px;
      background-color: #cecece;
    }

    button {
      font-size: inherit;
      background-color: #86c5c8;
      padding: 2px 14px;
      margin: 0px 2px;
    }
    input {
      font-size: inherit;
      border: 1px solid #b5b5b5;
    }
    select {
      border: 1px solid #b5b5b5;
    }

    pre {
      max-height: 170px;
      overflow: scroll;
      background-color: #fff;
    }

    .desc-inline {
      display: none;
      &[data-show] {
        display: inline-block;
        background-color: #f7f254;
        padding: 2px;
        vertical-align: -2px;
      }
    }

    input[type="number"] {
      text-align: right;
      width: 50px;
    }
    [name="roomId"] {
      width: 150px;
    }
    [name="userId"] {
      width: 85px;
    }
  }

}
</style>
